import * as React from 'react';

export const CheckboxGroupContext = React.createContext(false);
